/** General election day (local midnight). */
export const GENERAL_ELECTION = new Date(2026, 10, 3, 0, 0, 0);

/**
 * Whether `now` is before Election Day starts.
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isBeforeElectionDay = (now = new Date()) => GENERAL_ELECTION.getTime() > now.getTime();

/** First midnight after Election Day (local). */
export const DAY_AFTER_ELECTION = new Date(2026, 10, 4, 0, 0, 0);

/**
 * Whether `now` is before Election Day ends.
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isBeforeDayAfterElection = (now = new Date()) => DAY_AFTER_ELECTION.getTime() > now.getTime();
